import { render, staticRenderFns } from "./InterfaceFileUpload.vue?vue&type=template&id=40befeca"
import script from "./InterfaceFileUpload.vue?vue&type=script&lang=js"
export * from "./InterfaceFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports